import React from "react";

export const schedulerTextLabels = {
  manual: "Single texts", batch: "Batch texts", scheduled: "Scheduled / Quo-only", unknown: "Unknown source",
};

export default function SchedulerTextBreakdown({ counts }) {
  if (!counts) {return null;}
  return <div aria-label="Text message sources" className="tw-flex tw-flex-wrap tw-gap-x-4 tw-gap-y-2 tw-text-xs tw-text-gray-600">
    {Object.entries(schedulerTextLabels).map(([kind, label]) => <span key={kind}
      title={kind === "scheduled" ? "Includes inferred scheduled or Quo-only sends with no Foursite activity in the preceding 10 minutes. These messages do not add working time."
        : kind === "unknown" ? "The single-versus-batch origin could not be established." : "Recorded at the Foursite send action."}>
      {label} <strong className="tw-text-gray-900" style={{ fontVariantNumeric: "tabular-nums" }}>{counts[kind] || 0}</strong>
    </span>)}
  </div>;
}
